import { defineStore } from 'pinia'
import api from '@/services/api'
import { useAuthStore } from './auth'


export const useModulosStore = defineStore('modulos', {
  state: () => ({
    authStore: useAuthStore(),
    modulos: []
  }),
  actions: {
    async get() {

      const result = await api.get('/modulos', {
        headers: {
          Authorization: `Bearer ${this.authStore.access_token}`
        }
      })
      this.modulos = result.data
    },
    async update(id, valor) {

      const result = await api.put(`/modulos/${id}`, { valor }, {
        headers: {
          Authorization: `Bearer ${this.authStore.access_token}`
        }
      })

      if (result.data.id) {
        return { status: true }
      } else {
        return { status: false, message: result.data.message }
      }

    }
  }
})